import React, { ReactElement } from 'react';

import { Grid, GridItem, Heading, Text } from '@constellation/core';

interface PageHeadingProps {
  serviceName?: string;
  header?: string;
}

// Component to render the service name and the Page heading
export default function PageHeading({
  serviceName,
  header,
}: PageHeadingProps): ReactElement {
  return (
    <Grid>
      <GridItem>
        {serviceName && (
          <Text as="p" size="s2" weight="bold" marginBottom="03">
            {serviceName}
          </Text>
        )}
        <Heading size="s7" color="brand" marginBottom="07" role="heading">
          {header}
        </Heading>
      </GridItem>
    </Grid>
  );
}
